module.exports = __webpack_public_path__ + "static/media/stockhausen_blicke_36.83a4e07e.jpg";